module.exports = __webpack_public_path__ + "assets/269e234adce74afbe3baca3dd3ed5eaa.svg";